export default __webpack_public_path__ + "static/media/Podfic.bb0e1a08.png";